
import React from 'react';
import { NamedLink } from '../../components';
import css from './CategoryNavigationBar.module.css';

const CategoryNavigationBar = () => {
  const categories = [
    { label: 'Voyance', path: 's?pub_categories_annonce=has_all%3AVoyance' },
    { label: 'Astrologie', path: 's?pub_categoryLevel1=Astrologie' },
    { label: 'Tarot', path: 's?pub_categoryLevel1=Tarot' },
    { label: 'Numérologie', path: 's?pub_categoryLevel1=Numerologie' },
    { label: 'Coaching', path: 's?pub_categoryLevel1=Coaching' },
    { label: 'Energies', path: 's?pub_categoryLevel1=Energie' },
    { label: 'Naturopathie', path: 's?pub_categoryLevel1=Naturopathie' },
    { label: 'Animaux', path: 's?pub_categoryLevel1=Animaux' },
    { label: 'Autres', path: 's?pub_categoryLevel1=Autres' },
  ];

  return (
    <div className={css.sidebar}>
      <nav className={css.navigation}>
        {categories.map((category, index) => (
          <NamedLink
            key={index}
            name="SearchPage"
            to={category.path}
            className={css.categoryLink}
          >
            {category.label}
          </NamedLink>
        ))}
        <div className={css.authButtons}>
          <NamedLink
            name="SignupPage"
            className={css.authButton}
          >
            S'inscrire
          </NamedLink>
          <NamedLink
            name="LoginPage"
            className={css.authButton}
          >
            Se connecter
          </NamedLink>
        </div>
      </nav>
    </div>
  );
};

export default CategoryNavigationBar;
